import React from "react";
import { useParams } from "react-router-dom";
import { HD403 } from "./marineEngine/hd403";
import { HD404 } from "./marineEngine/hd404";
import { HD608 } from "./marineEngine/hd608";
import { HD611 } from "./marineEngine/hd611";
import { HD612 } from "./marineEngine/hd612";
import { HD614 } from "./marineEngine/hd614";
import { HD615 } from "./marineEngine/hd615";
import { HG401 } from "./generatorEngine/hg401";
import { HG403 } from "./generatorEngine/hg403";
import { HG404 } from "./generatorEngine/hg404";
import { HG608 } from "./generatorEngine/hg608";
import { HG611 } from "./generatorEngine/hg611";
import { HG612 } from "./generatorEngine/hg612";
import { HG614 } from "./generatorEngine/hg614";

export const Products = () => {

    const {product} = useParams()

    return(
        <>
        {product === 'hd403' ? <HD403/> : ''}
        {product === 'hd404' ? <HD404/> : ''}
        {product === 'hd608' ? <HD608/> : ''}
        {product === 'hd611' ? <HD611/> : ''}
        {product === 'hd612' ? <HD612/> : ''}
        {product === 'hd614' ? <HD614/> : ''}
        {product === 'hd615' ? <HD615/> : ''}
        {product === 'hg401' ? <HG401/> : ''}
        {product === 'hg403' ? <HG403/> : ''}
        {product === 'hg404' ? <HG404/> : ''}
        {product === 'hg608' ? <HG608/> : ''}
        {product === 'hg611' ? <HG611/> : ''}
        {product === 'hg612' ? <HG612/> : ''}
        {product === 'hg614' ? <HG614/> : ''}
        </>
    )
}